import React from 'react';
import numericFunction from "../../utils/NumericFunction";

const CardMorakhasi = ({usedLeave, entitledLeave, remainingLeave}) => {
    return (
        <div className="card-mo">
            <p>مرخصی استفاده شده : {numericFunction.e2p(usedLeave)}</p>
            <p>مرخصی استحقاقی : {entitledLeave}</p>
            <p>مرخصی مانده : {remainingLeave}</p>
        </div>
    );
};

export default CardMorakhasi;
